export const ADMIN = 'admin'
export const USER = 'user'
export const APPLICANT = 'applicant'
export const EMPLOYER = 'employer'